import * as React from "react";
import styles from "./stylesPromotionDetails.css";
import { PauseOutlined } from "@ant-design/icons";

const PromotionHeader = ({ status, title }) => (
  <header className="header">
    <h2 className="headerTitle">{title}</h2>
    <span className="statusBadge">{status}</span>
  </header>
);

const InfoRow = ({ label, value, subValue }) => (
  <div className="infoRow">
    <span className="label">{label}</span>
    <strong className="value">{value}</strong>
    {subValue && <span className="subValue">{subValue}</span>}
  </div>
);

const SplitInfoRow = ({ leftLabel, leftValue, rightLabel, rightValue }) => (
  <div className="splitRow">
    <div className="splitColumn">
      <span className="label">{leftLabel}</span>
      <strong className="value">{leftValue}</strong>
    </div>
    <div className="splitColumn">
      <span className="label">{rightLabel}</span>
      <strong className="value">{rightValue}</strong>
    </div>
  </div>
);

const ActionButtons = () => (
  <section className="actionSection">
    <div className="buttonGroup">
      <button className="primaryButton">
      <PauseOutlined />
        <span>Suspend</span>
      </button>
      <button className="secondaryButton">Edit</button>
    </div>
    <button className="finishButton">Finish Promo</button>
  </section>
);

function PromotionDetails() {
  return (
    <article className="promotionCard">
      <PromotionHeader status="Active" title="Details" />

      <InfoRow label="Promotion Type" value="Profit Boost" />

      <SplitInfoRow
        leftLabel="Start date"
        leftValue="Nov 28, 2024"
        rightLabel="End date"
        rightValue="–"
      />

      <InfoRow label="Expiration Period" value="7 days" />

      <SplitInfoRow
        leftLabel="Eligible bet type"
        leftValue="Parlay (SGP)"
        rightLabel="Prematch/Live"
        rightValue="All"
      />

      <SplitInfoRow
        leftLabel="Min. legs"
        leftValue="3"
        rightLabel="Max. legs"
        rightValue="8"
      />

      <SplitInfoRow
        leftLabel="Odds boost %"
        leftValue="20%"
        rightLabel="Progressive boost"
        rightValue="+5% each extra leg"
      />

      <SplitInfoRow
        leftLabel="Sports"
        leftValue="All"
        rightLabel="Leagues"
        rightValue="All"
      />

      <SplitInfoRow
        leftLabel="Teams"
        leftValue="All"
        rightLabel="Events"
        rightValue="All"
      />

      <SplitInfoRow
        leftLabel="Min. odds"
        leftValue="-"
        rightLabel="Max. odds"
        rightValue="+800"
      />

      <ActionButtons />
    </article>
  );
}

export default PromotionDetails;
